"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.range = void 0;
var range = function (a, b) {
    return Array.from({ length: b - a + 1 }, function (_, k) { return a + k; });
};
exports.range = range;
